"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _store = require("../store");
var _appConfigurationSlice = require("../features/appConfiguration/appConfigurationSlice");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
var StoreProvider = function StoreProvider(_ref) {
  var language = _ref.language,
    children = _ref.children;
  var storeRef = (0, _react.useRef)();
  if (!storeRef.current) {
    storeRef.current = (0, _store.makeStore)();
    storeRef.current.dispatch((0, _appConfigurationSlice.setHost)(language));
  }
  return __jsx(_reactRedux.Provider, {
    store: storeRef.current
  }, children);
};
var _default = StoreProvider;
exports["default"] = _default;